import { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "./styles/global.css";

import SeoHead      from "./components/SeoHead";
import Navbar       from "./components/Navbar";
import Footer       from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import HomePage     from "./pages/HomePage";
import AboutPage    from "./pages/AboutPage";
import FeaturesPage from "./pages/FeaturesPage";
import ContactPage  from "./pages/ContactPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getPageName = (pathname) => {
    if (pathname === "/about") return "about";
    if (pathname === "/features") return "features";
    if (pathname === "/contact") return "contact";
    return "home";
  };

  const page = getPageName(location.pathname);

  const nav = (p) => {
    const path = p === "home" ? "/" : `/${p}`;
    navigate(path);
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <ScrollToTop />

      {/* Updates <title>, meta description, OG tags, canonical per page */}
      <SeoHead page={page} />

      <Navbar page={page} nav={nav} scrolled={scrolled} />

      <Routes>
        <Route path="/" element={<HomePage nav={nav} />} />
        <Route path="/about" element={<AboutPage nav={nav} />} />
        <Route path="/features" element={<FeaturesPage nav={nav} />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>

      <Footer nav={nav} />

      {/* Floating WhatsApp button — visible on all pages */}
      <WhatsAppButton />
    </>
  );
}
